<!-- dev.vue -->
<template>
  <div class="dev-container">
    <h2>Gestione LocalStorage</h2>
    <p><strong>Stato operazione:</strong> {{ message }}</p>

    <div v-if="storageItems.length" class="storage-list">
      <h3>Elementi attuali in LocalStorage:</h3>
      <ul>
        <li v-for="item in storageItems" :key="item.key">
          <code>{{ item.key }}</code>: {{ item.value }}
        </li>
      </ul>
    </div>
    <p v-else>LocalStorage vuoto.</p>
  </div>
</template>

<script>
export default {
  name: 'DevStorage',
  data() {
    return {
      message: 'In elaborazione...',
      storageItems: []
    };
  },
  mounted() {
    this.handleStorageActions();
    this.refreshStorageList();
  },
  methods: {
    handleStorageActions() {
      // Supporta sia Vue Router (this.$route.query) sia i parametri nativi della URL
      const queryParams = this.$route && this.$route.query
        ? this.$route.query
        : Object.fromEntries(new URLSearchParams(window.location.search));

      // Caso 1: Cancellazione totale (?erase)
      if (Object.prototype.hasOwnProperty.call(queryParams, 'erase')) {
        localStorage.clear();
        this.message = 'Tutte le chiavi di localStorage sono state eliminate con successo.';
        return;
      }

      // Estrai la prima coppia chiave/valore passata nella query
      const keys = Object.keys(queryParams);
      if (keys.length === 0) {
        this.message = 'Nessun parametro fornito. Usa ?key=valore, ?key=null o ?erase.';
        return;
      }

      const targetKey = keys[0];
      const targetValue = queryParams[targetKey];

      // Caso 2: Rimozione chiave specifica (?key=null)
      if (targetValue === 'null' || targetValue === null) {
        localStorage.removeItem(targetKey);
        this.message = `Chiave "${targetKey}" rimossa da localStorage.`;
      } 
      // Caso 3: Scrittura / Aggiornamento chiave (?key=value)
      else {
        localStorage.setItem(targetKey, targetValue);
        this.message = `Chiave "${targetKey}" impostata con successo a "${targetValue}".`;
      }
    },
    refreshStorageList() {
      const items = [];
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        items.push({
          key,
          value: localStorage.getItem(key)
        });
      }
      this.storageItems = items;
    }
  }
};
</script>

<style scoped>
.dev-container {
  font-family: sans-serif;
  max-width: 600px;
  margin: 30px auto;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
}
.storage-list ul {
  list-style-type: none;
  padding: 0;
}
.storage-list li {
  padding: 6px 0;
  border-bottom: 1px solid #eee;
}
code {
  background: #f4f4f4;
  padding: 2px 5px;
  border-radius: 4px;
}
</style>